import React, { forwardRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { ColorPickerContent } from "./ColorPickerContent";

interface ColorPickerOverlayProps {
  color: string;
  onChange: (newColor: string) => void;
  // Optional callback when picker is toggled/shown
  onShow?: () => void;
  onHide?: () => void;
}

/**
 * A reusable overlay wrapper for the ColorPickerContent.
 * Uses Primereact's OverlayPanel and forwardRef to allow toggling from parent.
 */
export const ColorPickerOverlay = forwardRef<OverlayPanel, ColorPickerOverlayProps>(
  ({ color, onChange, onShow, onHide }, ref) => {
    return (
      <OverlayPanel ref={ref} onShow={onShow} onHide={onHide}>
        <ColorPickerContent color={color} onChange={onChange} />
      </OverlayPanel>
    );
  }
);

ColorPickerOverlay.displayName = "ColorPickerOverlay";
